/* eslint-disable no-unused-vars */

/**
 * @summary Creates a memoized function with a max cache size of `MAX_CACHE_SIZE`
 * @generator
 */
function memoize (fn) {
  const MAX_CACHE_SIZE = 1000;

  let cache = {};
  const slice = Array.prototype.slice;

  return function () {
    const args = slice.call(arguments);

    if (Object.keys(cache).length >= MAX_CACHE_SIZE) cache = {};

    if (args in cache) return cache[args];

    return (cache[args] = fn.apply(this, args));
  };
}

/**
 * @summary Creates a memoized, *dereferenced* function contingent on a function's first or only argument
 * @generator
 */
function memoFirst (fn) {
  const cache = new WeakMap();

  return function (arg) {
    if (!cache.has(arg)) cache.set(arg, fn(arg));
    return cache.get(arg);
  };
}

function isObject (x) {
  return toString.call(x) == '[object Object]'; // eslint-disable-line eqeqeq
}

function isString (x) {
  return typeof x === 'string' || x instanceof String;
}

/**
 * @summary Determine if an object is NOT empty
 * @param {any} candidate Prospective object to test
 */
function objNotEmpty (candidate) {
  if (isObject(candidate)) {
    return Object.keys(candidate).length > 0;
  }
  return false;
}

export {
  memoize,
  isString,
  objNotEmpty,
  isObject
};
